import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {StorageService} from './storage.service';
import {URL_PORTAL_SERVICOS_API} from "../util/constants";

@Injectable()
export class SolicitacoesService {

  constructor(
    private httpClient: HttpClient,
    private storageSercice: StorageService
  ) { }

  getSolicitacoesByUsuario(nomeUsuario: string): Observable<any> {
    return this.httpClient.get(URL_PORTAL_SERVICOS_API + '/solicitacao/solicitacoesEnviadas?nomeUsuario=' + nomeUsuario);
  }

  incluirSolicitacaoExterna(solicitacao): Promise<any> {
    return this.httpClient.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao/incluirExterna`, solicitacao).toPromise();
  }

  enviarParaAprovacao(solicitacao: any): Promise<any> {
    return this.httpClient.post(URL_PORTAL_SERVICOS_API + '/solicitacao/enviarParaAprovacao', solicitacao).toPromise();
  }

  enviarParaAprovacaoProducao(solicitacao: any): Promise<any> {
    return this.httpClient.post(URL_PORTAL_SERVICOS_API + '/solicitacao/enviarParaAprovacaoProducao', solicitacao).toPromise();
  }

  getJustify(solicitacao: any): Promise<any> {
    return this.httpClient.get(URL_PORTAL_SERVICOS_API + '/parecer/buscarAprovacoes?idSolicitacao='+solicitacao).toPromise();
  }

  getEstabFilhos(numero, ano, page, size, cnes) {
    let url = `${URL_PORTAL_SERVICOS_API}/solicitacao/pesquisarEstabelecimentosFilhos?numero=${numero}&ano=${ano}&size=${size}&page=${page}`;
    if (cnes) {
      url = url + `&cnes=${cnes}`;
    }
    return this.httpClient.get(url).toPromise();
  }

  postEstabFilho(nuSolicitacao, nuCnes) {
    const body = {
      nuSolicitacao,
      nuCnes,
    };
    const url = `${URL_PORTAL_SERVICOS_API}/estabelecimento-filho`;

    return this.httpClient.post(url, body).toPromise();
  }

  deleteEstabFilho(id) {
    const url = `${URL_PORTAL_SERVICOS_API}/estabelecimento-filho/${id}`;

    return this.httpClient.delete(url).toPromise();
  }

  async validarResponsavelCnes(cnes) {
    const tokenBc: any = this.storageSercice.getTokenBc();
    const url = `${URL_PORTAL_SERVICOS_API}/estabelecimento/validar-responsavel/${cnes}`;
    return this.httpClient.get(url, {
      headers: {
        AuthorizationSepro: `${tokenBc}`,
      }
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/solicitacoes.service.ts